import cn from 'classnames';
import styles from './CountryCard.module.css';
import { FunctionComponent } from 'react';

export interface ICountryProps {
  countryName: string;
  countryFlag: string;
  className?: string;
}

const CountryCard: FunctionComponent<ICountryProps> = ({countryName, countryFlag, className}) => {  
  
// const getFlagUrl = (code: string) => `https://flagcdn.com/w40/${code.toLowerCase()}.png`;

  return (
    <div className={cn(styles.counrtyWrap, className)}>
        <div className={cn(styles.counrtyAvatar)}
        >
            {/* <Image src={getFlagUrl(countryFlag)} alt={countryName} /> */}
            {countryFlag}
        </div>
        <div className={styles.countryName}>
            {countryName}
        </div>
    </div>
  );
};

export default CountryCard;
